module.exports = __webpack_public_path__ + "static/news9-3-4861c2046eecdcd866d5966b9435165f.jpg";